import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { formatQueryError } from '../services/queryError';
const MAX_NOTE_LEN = 2000;
export const RevisionModal = ({ open, onClose, onSubmit, currentVersion }) => {
    const [note, setNote] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState();
    if (!open) {
        return null;
    }
    const trimmed = note.trim();
    const canSubmit = trimmed.length > 0 && trimmed.length <= MAX_NOTE_LEN;
    const handleSubmit = async () => {
        if (!canSubmit) {
            return;
        }
        setSubmitting(true);
        setError(undefined);
        try {
            await onSubmit(trimmed);
            setNote('');
            onClose();
        }
        catch (err) {
            // RTK Query rejects with FetchBaseQueryError / SerializedError, neither of
            // which have a .message field — reading err.message left the modal with a
            // blank error and no signal that regenerate failed.
            setError(formatQueryError(err));
        }
        finally {
            setSubmitting(false);
        }
    };
    const showSoftWarning = currentVersion >= 4;
    return (_jsx("div", { className: "modal modal-open", children: _jsxs("div", { className: "modal-box", children: [_jsx("h3", { className: "font-semibold text-lg", children: "Request revision" }), _jsx("p", { className: "text-sm opacity-70 mt-1", children: "Describe what should change. The note is appended to the AI prompt for the next regeneration. PII rules and the document contract still apply \u2014 the operator can steer, not override." }), showSoftWarning ? (_jsx("div", { className: "alert alert-warning mt-3 text-sm", children: _jsxs("span", { children: ["This case already has ", currentVersion - 1, " revisions. If the narrative still isn't right, consider rejecting the defense instead."] }) })) : null, _jsx("textarea", { className: "textarea textarea-bordered w-full mt-3", rows: 6, placeholder: 'e.g. "Lead with the cancellation policy acceptance, not the room-quality dispute."', value: note, onChange: e => setNote(e.target.value), maxLength: MAX_NOTE_LEN, "aria-label": "Revision note" }), _jsxs("div", { className: "text-xs opacity-70 text-right", children: [trimmed.length, "/", MAX_NOTE_LEN] }), error ? (_jsxs("p", { className: "text-sm text-red-600 mt-2", children: ["Error: ", error] })) : null, _jsxs("div", { className: "modal-action", children: [_jsx("button", { className: "btn btn-ghost btn-sm", onClick: onClose, disabled: submitting, children: "Cancel" }), _jsx("button", { className: "btn btn-primary btn-sm", disabled: !canSubmit || submitting, onClick: handleSubmit, children: submitting ? 'Submitting…' : 'Request revision' })] })] }) }));
};
